import H from '@here/maps-api-for-javascript';
import { getDeliveryEditing, getJobMarkerIcon } from '../../../../icons/marker';
import { MARKER_ANCHOR } from './markerConstants';

export function setMarkerIcon(marker, props) {
  const anchor = props.isEditing ? MARKER_ANCHOR.EDITING : MARKER_ANCHOR.NORMAL;
  const iconSvg = props.isEditing
    ? getDeliveryEditing()
    : getJobMarkerIcon(props.highPriority, props.isPickup);
  marker.setIcon(new H.map.Icon(iconSvg, { anchor }));
}

export function createMarker(coords, props) {
  const marker = new H.map.Marker({ lat: coords[1], lng: coords[0] }, { volatility: true });
  marker.setData(props);
  setMarkerIcon(marker, props);
  return marker;
}

export function updateGroupMarkers(
  geoJson,
  group,
  ui,
  translations,
  map,
  dispatch,
  ordersRef,
  solution,
  onMarkerDragEnd,
  attachHoverEventsFn,
  attachInteractionEventsFn,
) {
  const features = geoJson?.geo?.features || [];
  const newMarkerIds = new Set();
  const existingMarkers = new Map();

  group.getObjects().forEach((marker) => {
    existingMarkers.set(marker.id, marker);
  });

  features.forEach((feature) => {
    if (feature.geometry.type === 'Point') {
      const coords = feature.geometry.coordinates;
      const props = feature.properties || {};
      const id = props.id || `${coords[0]}_${coords[1]}`;
      newMarkerIds.add(id);

      const existingMarker = existingMarkers.get(id);

      if (existingMarker) {
        const currentData = existingMarker.getData() || {};

        const needsUpdate =
          currentData.isEditing !== props.isEditing ||
          currentData.isPickup !== props.isPickup ||
          currentData.highPriority !== props.highPriority;

        if (needsUpdate) {
          existingMarker.setData(props);
          setMarkerIcon(existingMarker, props);
        } else {
          existingMarker.setData(props);
        }
        existingMarker.draggable = true;
      } else {
        const marker = createMarker(coords, props);
        marker.id = id;
        attachHoverEventsFn(marker, ui, translations, map, ordersRef, dispatch, solution);
        attachInteractionEventsFn(
          marker,
          feature,
          dispatch,
          ordersRef,
          solution,
          onMarkerDragEnd,
          map,
        );
        group.addObject(marker);
      }
    }
  });

  [...group.getObjects()].forEach((marker) => {
    if (!newMarkerIds.has(marker.id)) {
      group.removeObject(marker);
    }
  });
}
